import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import SideBannerImage from '../SideBanner/SideBannerImage'
import MobileStoryItem from './MobileStoryItem'



interface VideoImage {
  birting? : string,
  backgroundImage : any,
  visible: boolean
}


export default ({ data }) => {

  const [images, setImages] = useState<Array<VideoImage>>(data.allStory.edges.map((edge)=>{
    return {
      backgroundImage : edge.node.backgroundImage,
      birting : edge.node.birting,
      visible : false
      }
  }))

  const checkImages = () =>{
    const updatedImages : Array<VideoImage> = images.map((item)=>{
      const birting = parseFloat(item.birting);
      const now = Math.round((new Date()).getTime() / 1000);
      const isVisible = (now >= birting)
        return {
          backgroundImage: item.backgroundImage,
          birting : item.birting,
          visible : isVisible
        }
    })
    setImages(updatedImages);
  }
  
  
  useEffect(()=>{
    checkImages()
    const inter = setInterval(()=>{
        checkImages()
    }, 3000)
    return ()=>{
      clearInterval(inter)
    }
  },[])
	return (
		<MobileContainer>
        <MobileStoryItemContainer>
          <PageTitle>Bíósalur</PageTitle>
          <MobileStoryItem  visible={images[0].visible} data={data.allStory.edges[0].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
          <MobileStoryItem  visible={images[1].visible} data={data.allStory.edges[1].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
          <MobileStoryItem  visible={images[2].visible} data={data.allStory.edges[2].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
          <MobileStoryItem  visible={images[3].visible} data={data.allStory.edges[3].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
          <MobileStoryItem  visible={images[4].visible} data={data.allStory.edges[4].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
          <MobileStoryItem  visible={images[5].visible} data={data.allStory.edges[5].node} bg={data.afsakidhle.childImageSharp.fluid.src} />
        </MobileStoryItemContainer>
      </MobileContainer>
	)
}

const MobileStoryItemContainer = styled.div`
  margin-top: max(50px, 5vh);
  width: 80vw;
`

const MobileContainer = styled.div`
  padding-bottom: 30px;
  background: #7D2377;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
`

const PageTitle = styled.h1`
  font-size: 32px;
  color: white;
  width: 100%;
  text-align: Center;
  padding-top: 100px;
  padding-bottom: 30px;
  font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
  margin-bottom: 30px;
`